<div class="textstosend textslist page container">
  <div #textsListHeader class="textslist__header">
    <div class="row">
      <div class="col-12">
        <app-texts-menu [todo]="this.textsTodo.RECORD" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <app-texts-list-filters
          [speakersList]="this.speakersList"
          [languesList]="this.languesList"
          [phasesVocalesList]="this.phasesVocalesList"
          [typesMessageList]="this.typesMessageList"
          [categoryPV]="categoryPV"
          (resetFiltersEvent)="
            this.getPVsList($event); this.selectedSpeaker = undefined
          "
          (selectSpeakerEvent)="this.onSelectSpeaker($event)"
          [isLoading]="this.isLoading"
          (search)="this.getPVsList($event)"
          (selectLangEvent)="this.onSelectLang($event)"
          (exportDataEvent)="this.exportPvToSend($event)"
          [hideFilters]="['ZMS_DATEPVDIST1']"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center mb-2">
          @if (this.textsToPatchIdList.length <= 0) {
<div >
            <button class="btn btn-disabled" disabled>Prévisualiser les textes</button>
            <button class="btn btn-disabled ms-2" disabled>
              Sélectionnez les textes à envoyer
            </button>
          </div>
}
          @if (this.textsToPatchIdList.length > 0) {
<div>
            <button class="btn btn-secondary"
            (click)="this.showSelectedText(textsToPreview)">
              <i class="fa-regular fa-eye"></i>
              Prévisualiser les textes
            </button>
            <button
              class="btn ms-2"
              [ngClass]="{
              'btn-disabled': !this.selectedSpeaker,
              'btn-primary': this.selectedSpeaker
            }"
              type="submit"
              (click)="this.openSendTextsDialog()"
              [disabled]="this.selectedSpeaker === undefined || this.isLoading"
            >
              <i class="fa-solid fa-paper-plane"></i>
              <span class="text-capitalize ms-2">Envoyer</span>
              {{ this.textsToPatchIdList.length }} texte{{
                this.textsToPatchIdList.length > 1 ? "s" : ""
              }} ({{countNbMotToSend}} mots)
            </button>
          </div>
}


          @if (!this.selectedSpeaker || !this.langSelected || !categorySelected) {
<span
           
            class="textslist__error ms-2"
            >Sélectionnez {{ !this.selectedSpeaker ? "un·e comédien·ne" : "" }}
            {{ !this.selectedSpeaker && !this.langSelected ? "et" : "" }}
            {{ !this.langSelected ? "une langue" : "" }}
            {{ !this.selectedSpeaker && !this.langSelected && !categorySelected ? "et" : "" }}
            {{ !categorySelected ? "une catégorie" : ""}} pour envoyer des textes. </span>
} @else {

            <div ngbDropdown class="d-inline-block ms-3">
              <button
                type="button"
                class="btn btn-outline-primary"
                id="fillSeanceDropdown"
                ngbDropdownToggle
              >
                Compléter les séances
              </button>

              <div ngbDropdownMenu aria-labelledby="fillSeanceDropdown">
                @for (count of this.speakerCountTodayDetails; track count) {

                  @if (count.remain > 0) {
<button
                   
                    ngbDropdownItem
                    (click)="
                      this.page = 1;
                      this.limit = count.remain;
                      this.getPVsList()
                    "
                  >
                    Afficher {{ count.remain }} texte(s) attribuables
                  </button>
}
                
}
              </div>
            </div>


              @if (speakCapacity?.modeFacturation === 'seance') {
                  <span class="ms-2">
                    {{speakCapacity?.textesEnvoyes}} textes envoyés aujourd'hui sur un total possible de {{speakCapacity?.capaciteJour}}
                      (soit {{ speakCapacity?.nbTextesParSeance }} par séance).
                        @if (!this.speakerAvailable && this.selectedSpeaker) {
<span class="d-block textslist__error">
                         <i class="fa-solid fa-exclamation-triangle me-2"></i>
                            {{ this.selectedSpeaker.prenom }} {{ this.selectedSpeaker.nom }} ne travaille pas aujourd'hui
                        </span>
}
                  </span>
              } @else {
                  <span class="ms-2">
                    {{speakCapacity?.textesEnvoyes}} textes envoyés aujourd'hui sur un total possible de {{speakCapacity?.nbTextesMaxJour}}.
                      @if (!this.speakerAvailable && this.selectedSpeaker) {
<span class="d-block textslist__error">
                         <i class="fa-solid fa-exclamation-triangle me-2"></i>
                          {{ this.selectedSpeaker.prenom }} {{ this.selectedSpeaker.nom }} ne travaille pas aujourd'hui
                        </span>
}
                  </span>
              }

          
}

          
        </div>
      </div>
<!--      TODO : LES textes groupés-->

      @if (this.selectedSpeaker && this.langSelected;) {
<div class="col-3" ngbDropdown>

        <button type="button" class="btn btn-outline-primary" id="countGroupedText" ngbDropdownToggle>
          Grouper les messages par nombre de texte
        </button>
        <div ngbDropdownMenu aria-labelledby="countGroupedText">
          <ng-container>
            <button ngbDropdownItem (click)="this.groupTexteForCompletion(0)">Sans tri</button>
            <button ngbDropdownItem (click)="this.groupTexteForCompletion(1)">1</button>
            <button ngbDropdownItem (click)="this.groupTexteForCompletion(2)">2</button>
            <button ngbDropdownItem (click)="this.groupTexteForCompletion(3)">3</button>
            <button ngbDropdownItem (click)="this.groupTexteForCompletion(4)">4</button>
            <button ngbDropdownItem (click)="this.groupTexteForCompletion(5)">5</button>
          </ng-container>
        </div>
      </div>
}
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <table class="textslist__table table">
        <thead [style]="{ top: this.textsListHeaderHeight }">
          <tr>
            <th>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  #selectAllCheckbox
                  (change)="
                    this.selectAllTexts(
                      selectAllCheckbox.checked,
                      this.prisesVoixGrouped.slice((this.page-1) * this.limit, this.page * this.limit),
                      this.postObjectKeys
                    )
                  "
                  [disabled]="!this.selectedSpeaker || !this.langSelected || !categorySelected"
                  [checked]="
                    this.textsToPatchIdList.length === this.prisesVoix.length &&
                    this.selectedSpeaker &&
                    this.prisesVoix.length > 0
                  "
                />
              </div>
            </th>
            <th>Client</th>
            <th>Date livraison</th>
            <th>Comédien·ne</th>
            <th><i class="fa-solid fa-globe"></i></th>
            <th><i class="fa-solid fa-venus-mars"></i></th>
            <th>Type message</th>
            <th>Guide</th>
            <th>Phase vocale</th>
            <th>LER</th>
            <th><i class="fa-solid fa-language"></i></th>
            <th>Mots</th>
          </tr>
        </thead>
        <tbody>
          @if (this.isLoading) {
<tr>
            <td class="text-center" colspan="12">
              <div class="textslist__table__loader">
                <app-loader />
              </div>
            </td>
          </tr>
} @else {

            @for (text of this.prisesVoixGrouped | slice: (this.page-1) * this.limit : this.page * this.limit ; track text; let i = $index) {
<tr (dblclick)="testShowModal(text)">
              <!--  -->
              <td
                [ngClass]="{
                  'textslist__table__select--match':
                    (this.smartSelectEnabled &&
                      i < this.prisesVoix.length &&
                      this.prisesVoix[i + 1]?.ZMS_NUMERO +
                        '-' +
                        this.prisesVoix[i + 1]?.CLIENT_FINAL ===
                        text.ZMS_NUMERO + '-' + text.CLIENT_FINAL) ||
                    (this.smartSelectEnabled &&
                      i > 0 &&
                      this.prisesVoix[i - 1]?.ZMS_NUMERO +
                        '-' +
                        this.prisesVoix[i - 1]?.CLIENT_FINAL ===
                        text.ZMS_NUMERO + '-' + text.CLIENT_FINAL)
                }"
                class="textslist__table__select"
              >
                <div class="form-check">
                  <input
                    #selectTextCheckbox
                    class="form-check-input"
                    type="checkbox"
                    [disabled]="!this.selectedSpeaker || !this.langSelected || !categorySelected"
                    [value]="
                      text.ZMS_NUMERO +
                      '-' +
                      text.ZMS_LIVRAISON +
                      '-' +
                      text.ZMS_MESSAGE +
                      '-' +
                      text.RANGPV +
                      '-' +
                      text.CLIENT_FINAL
                    "
                    [checked]="
                      this.itemShouldBeChecked(
                        text.ZMS_NUMERO +
                          '-' +
                          text.ZMS_LIVRAISON +
                          '-' +
                          text.ZMS_MESSAGE +
                          '-' +
                          text.RANGPV +
                          '-' +
                          text.CLIENT_FINAL
                      )
                    "
                    (click)="
                      this.addToSendList(
                        selectTextCheckbox.checked,
                        selectTextCheckbox.value,
                        this.smartSelectEnabled,
                        this.prisesVoix,
                        this.postObjectKeys
                      )
                    "
                  />
                </div>
              </td>
              <td [ngbTooltip]="text.LIBELLE_CLIENT_FINAL" container="body">
                {{ text.CLIENT_FINAL }} -
                {{ text.LIBELLE_CLIENT_FINAL | truncate : 10 }}
              </td>
              <td>{{ text.ZMS_DATELIVRAISON | date : "dd/MM/yyyy" }}</td>
              <td>{{ text.PRENOM_COMEDIENNE }} {{ text.NOM_COMEDIENNE }}</td>
              <td>{{ this.getCodes(text.LANGUE, this.languesList) }}</td>
              <td>{{ text.GENRE | truncate : 1 : "" }}</td>
              <td>
                {{
                  this.getLibelles(text.ZMS_TYPEMESSAGE, this.typesMessageList)
                }}
              </td>
              <td ngbTooltip="{{ text.ZMS_GUIDE }}" container="body">
                {{ text.ZMS_GUIDE | truncate : 20 }}
              </td>
              <td>
                {{
                  this.getLibelles(text.ZMS_PHASEVOCALE, this.phasesVocalesList)
                }}
              </td>
              <td>
                @if (text.LER !== null) {
<button
                 
                  [ngbTooltip]="text.LER"
                  container="body"
                  class="btn-invisible"
                >
                  <i class="fa-solid fa-exclamation-circle"></i>
                </button>
}
              </td>
              <td>
                @if (text.ZMS_PVTRADUCTION1 === 'X') {
<div>
                  <div
                    class="textslist__translationstatus"
                    [ngClass]="{
                      'textslist__translationstatus--sent':
                        text.ZMS_PVENVOITRAD1 !== null && !this.isCegidNullDate(text.ZMS_PVENVOITRAD1),
                      'textslist__translationstatus--done':
                        text.ZMS_PVRECEPTIONTRAD1 !== null && !this.isCegidNullDate(text.ZMS_PVRECEPTIONTRAD1)
                    }"
                  ></div>
                </div>
}
              </td>
              <td>
                {{ countWords(text.ZMS_PVTEXTE) }}
              </td>
            </tr>
}
          
}
          @if (this.prisesVoix?.length === 0 && !this.isLoading) {
<tr>
            <td class="textslist__table__empty" colspan="12">Aucun résultat</td>
          </tr>
}
          
        </tbody>
      </table>
    </div>
  </div>

  @if (this.showFocusModalFromToSend) {
<app-text-focus />
}

<!--  TODO voir implémentation pour template générique -->
<!--  <app-texts-preview *ngIf="this.showModalPreviewTexts" (modalClose)="showModalPreviewTexts" [textsForPreview]="textsForPreview"/>-->
  <ng-template #textsToPreview let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Prévisualisation des textes : </h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="row fw-bold sticky-top p-2 m-1" style="box-shadow: 0px 8px 9px 0px rgba(0,0,0,0.1); border-radius: 10px ">
      <div class="col-3">Client : </div>
      <div class="col-3">Phase vocale :</div>
      <div class="col-6">Texte : </div>
    </div>
    <div class="modal-body">
      @for (text of this.textsForPreview; track text) {
<div>
        <div class="row ">
          <div class="col-3">{{text.CLIENT_FINAL}} - {{ text.LIBELLE_CLIENT_FINAL }}</div>
          <div class="col-3">{{this.getLibelles(text.ZMS_PHASEVOCALE, this.phasesVocalesList) }}</div>
          <div class="col-6">{{ text.ZMS_PVTEXTE}}</div>
        </div>
        <hr class="ms-3 me-3">
      </div>
}
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="modal.close()">Fin</button>
    </div>
  </ng-template>

  <app-dialog
    #postDialog
    title="Envoyer les textes"
    [visibility]="this.showValidationDialog"
    (closeDialogEvent)="
      this.showValidationDialog = $event;
      this.isPostingOver && this.getPVsList()
    "
  >
    @if (this.selectedSpeaker) {
<app-post-states
     
      [isPosting]="this.isPosting"
      [isPostingOver]="this.isPostingOver"
      [postError]="this.postError"
      readyMessage="Vous allez envoyer {{
        this.textsToPatchIdList.length
      }} texte(s) à
      {{ this.selectedSpeaker.prenom }} {{ this.selectedSpeaker.nom }}"
      postingMessage="Les textes sont en cours d'attribution"
      completeMessage="Les textes ont été attribués avec succès"
    />
}
    @if (!this.isPosting && !this.isPostingOver && !this.postError) {
<div>
      <div class="datepicker form-floating mt-3 mb-2 col-8">
        <input
          [(ngModel)]="dateEstimation"
          type="text"
          class="form-control"
          id="dateEstime"
          name="dateEstime"
          placeholder=""
          ngbDatepicker
          #d="ngbDatepicker"
          (click)="d.toggle()"
          (dateSelect)="checkSeance()"
        />
        <label for="dateEstime" class="form-label">Date estimée de découpe</label>
      </div>
    </div>
}
    @if (!this.isPosting && !this.isPostingOver && !this.postError && this.seanceDuo) {
<div>
      <div class="form-check form-switch mt-4">
        <input class="form-check-input" type="checkbox" name="" id="" [(ngModel)]="this.createNewSeance">
        <label class="form-check-label" for="">Créer une nouvelle séance</label>
      </div>
    </div>
}
    <div dialog-footer>
      @if (!this.isPosting && !this.isPostingOver && !this.postError) {
<div>
        <button class="btn btn-danger" (click)="this.postDialog.closeDialog()">
          Annuler
        </button>
        @if (this.selectedSpeaker) {
<button
         
          class="btn btn-primary ms-2 me-4"
          (click)="this.sendTexts(true)"
          [disabled]="!this.seanceHasBeenChecked"
        >
          <i class="fa-solid fa-envelope-circle-check"></i>
          Valider et notifier par email
        </button>
}
        @if (this.selectedSpeaker) {
<button
         
          class="btn btn-success"
          (click)="this.sendTexts()"
          [disabled]="!this.seanceHasBeenChecked"
        >
          Valider
        </button>
}
      </div>
}
      @if (this.isPostingOver) {
<div>
        <button
          class="btn btn-success me-2"
          (click)="this.getPVsList(); this.postDialog.closeDialog()"
        >
          Fermer
        </button>
      </div>
}
      @if (this.postError) {
<div>
        <button
          class="btn btn-danger me-2"
          (click)="this.postDialog.closeDialog()"
        >
          Fermer
        </button>
      </div>
}
    </div>
  </app-dialog>

  @if (!this.isLoading) {
<app-pagination
   
    [page]="this.page"
    [limit]="this.limit"
    [collectionSize]="this.collectionSize"
    (changePageEvent)="this.page = $event"
    (changeLimitEvent)="this.limit = $event"
  />
}
</div>
